import { observer } from "mobx-react-lite"
import { relative } from "path"
import { ReactNode, useEffect, useRef, useState } from "react"
import Loader from "../components/Loader"
import UserImage from "../components/UserImage"
import { VChatComp, VChatRecep, VChatUser } from "../components/VChatComp"
import { useAudioPlayer } from "../customHooks/useAudioPlayer"
import { RecorderType } from "../models/app/RecorderType"
import { MAX_TEXT_LENGTH } from "../models/constants"
import { rootStore } from "../StApp"
import ChatStore from "../stores/ChatStore"
import { RecorderStore } from "../stores/RecorderStore"
import VChatDirectStore from "../stores/VChatDirectStore"


const ChatContainerComp = observer((props: { store: VChatDirectStore }) => {

    const messagesEndRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        props.store.loadVChats()
    }, [])

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    //    if(messagesEndRef.current) {
    //        messagesEndRef.current.scrollTop = messagesEndRef.current!.scrollHeight
    //        console.log('scrolled')
    //        console.log(messagesEndRef.current!.scrollHeight)
    //     }
    } )

    switch (props.store.prog) {
        case 'LOADING': return <div style={{
            overflow: 'scroll',
            height: '80%'
        }} ><Loader /></div>

        case 'SUCCESS': return (<div style={{
            overflow: 'scroll',
        }}>
            <ul >
                {props.store.chatMsgList.map(item => <VChatComp store={props.store} chatMsg={item} key={item.msgId} />)}
            </ul>
            <div ref={messagesEndRef} ></div>
        </div>);

        default: return <p>FAILED</p>
    }

})




const ChatRecorderButton = observer((props: { chatStore: VChatDirectStore }) => {

    const chatStore = props.chatStore
    const recorderStore = props.chatStore.recorderStore

    function computeCompleteP() {
        let compP = recorderStore.recordTimer / recorderStore.recorderType * 100
        return `${compP}%`
    }

    function handleVoice() {

        switch (recorderStore.recordState) {
            case 'recording': chatStore.stopRecording()
                break;
            case 'init':
            case 'stop': chatStore.recordVoice()
                break;

        }

    }

    return (<button className='chat-voice-button' onClick={handleVoice}>
        <i className="material-icons" style={{
            fontSize: 25,
            zIndex: 10,
            position: 'relative'
        }}>mic</i>
        <div className='record-progress' style={{
            height: computeCompleteP()
        }}></div>
    </button>);
})



function ChatInputAudPlayer(props: { srcUrl: string }) {

    const { audioRef, duration, isPlayingState, pauseAudio, playAudio, curTime } = useAudioPlayer()

    function computeCompleteP() {
        let compP = curTime / duration * 100
        return `${compP}%`
    }

    return (<button className='chat-voice-button'>
        <audio ref={audioRef} src={props.srcUrl} preload='metadata'></audio>
        {
            isPlayingState == true ?
                <i className='material-icons' onClick={pauseAudio} style={{zIndex:10, position: 'relative'}} >pause</i> :
                <i className='material-icons' onClick={playAudio} style={{zIndex:10}} >play_arrow</i>

        }
        <div className='play-progress' style={{
            height: computeCompleteP()
        }}></div>
    </button>);
}


const ChatInputContainer = observer((props: { chatStore: VChatDirectStore }) => {

    const chatStore = props.chatStore
    const recorderStore = props.chatStore.recorderStore
    const inputRef = useRef<HTMLInputElement>(null)

    function sendChat(){
        chatStore.sendVChat()
        inputRef.current!.value = ''
    }



    return (<div className='chat-input-container'>
        <div className='flex-row center-align chat-input-text-container  '  style={{position:'relative', flexGrow:1}} >
            <input ref={inputRef} type="text" name="" className='input-chat-text' maxLength={20} onChange={e=>chatStore.updateCurrText(e.target.value)} />
            <p style={{position:'absolute', right:5}} >{props.chatStore.currChatText.length}/{MAX_TEXT_LENGTH}</p>
        </div>
        <ChatRecorderButton chatStore={chatStore} />
        {recorderStore.recordState == 'stop'?<ChatInputAudPlayer srcUrl={recorderStore.srcUrl}></ChatInputAudPlayer>: null}
        <div style={{
            width: 10
        }}></div>
        <button className='chat-voice-button' onClick={sendChat} disabled={chatStore.currChatText == ''|| recorderStore.blob == null} >
            <i className="material-icons" style={{
                fontSize: 25,
                zIndex: 10
            }}>send</i>
        </button>
    </div>);
})


const VChat = () => {

    const [recorderStore] = useState(new RecorderStore(RecorderType.VNOTE))
    const [store] = useState(new VChatDirectStore(rootStore.mainStore.currentChatId, recorderStore))

    // function genList(): ReactNode{

    //     const list = []

    //     for(let i =1; i<=100; i++){
    //         if(i%2 == 0)
    //          list.push(<VChatUser/>)
    //         else
    //          list.push(<VChatRecep/>) 
    //     }

    //     return list
    // }

    return (
        <div className='container' style={{ height: window.innerHeight }} >
            <div className='flex-row center-align chat-header '  >
                <UserImage userName='SB' />
                <h2 style={{ marginLeft: 10 }} >{rootStore.mainStore.currentVChatterId}</h2>
            </div>
            <ChatContainerComp store={store} />
            <ChatInputContainer chatStore={store} />

        </div>
    )

}

export default observer(VChat)